/* Trust-video i hjørnet (Kasper, medejer). Markup i sections/soullix-trust-video.liquid.
   Den lille boble kører uden lyd på hver side, indtil videoen er set færdig i afspilleren.
   Derefter ligger den som en lille rund boble med ansigtet og uden autoplay.
   Krydset skjuler den resten af besøget. */
(function () {
  'use strict';

  function noop() {}
  function store(kind) {
    try {
      var s = window[kind];
      s.setItem('__sxtv', '1');
      s.removeItem('__sxtv');
      return s;
    } catch (e) {
      return null;
    }
  }
  var LS = store('localStorage');
  var SS = store('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function put(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) {} }
  function drop(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(noop); return p; }
  function focus(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function frame(fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); }

  function init() {
    var wrap = document.getElementById('sxtv-wrap');
    var root = document.getElementById('sxtv');
    if (!wrap || !root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var design = !!(window.Shopify && window.Shopify.designMode);
    var full = root.getAttribute('data-full');
    var preview = root.getAttribute('data-preview') || full;
    var teaser = parseInt(root.getAttribute('data-teaser'), 10) || 10;
    // Nøglerne følger videoen, så en ny video bliver vist for alle igen
    var vid = (full.match(/[0-9a-f]{32}/) || [String(full.length)])[0].slice(0, 10);
    var K_SEEN = 'sxtv_seen_' + vid;
    var K_POS = 'sxtv_pos_' + vid;
    var K_HIDE = 'sxtv_hidden';
    var K_TEST = 'sxtv_test';

    var q = location.search;
    if (/[?&]sxtv=reset\b/.test(q)) { drop(LS, K_SEEN); drop(LS, K_POS); drop(SS, K_HIDE); put(SS, K_TEST, '1'); }
    if (/[?&]sxtv=1\b/.test(q)) put(SS, K_TEST, '1');
    if (/[?&]sxtv=0\b/.test(q)) drop(SS, K_TEST);

    var enabled = design || root.getAttribute('data-enabled') === 'true' || get(SS, K_TEST) === '1';
    if (!enabled || (!design && get(SS, K_HIDE) === '1')) return;

    // Op i body, så ingen forælder med transform eller z-index låser position: fixed
    if (wrap.parentNode !== document.body) document.body.appendChild(wrap);

    var bubble = root.querySelector('.sxtv__bubble');
    var xBtn = root.querySelector('.sxtv__x');
    var panel = document.getElementById('sxtv-panel');
    var card = panel.querySelector('.sxtv-panel__card');
    var big = panel.querySelector('.sxtv-panel__video');
    var prog = panel.querySelector('.sxtv-panel__prog i');
    var muteBtn = panel.querySelector('[data-sxtv-mute]');
    var closeBtn = panel.querySelector('[data-sxtv-close]');
    var endEl = panel.querySelector('.sxtv-panel__end');
    var replayBtn = panel.querySelector('[data-sxtv-replay]');
    var askLink = panel.querySelector('[data-sxtv-ask]');

    var seen = !design && get(LS, K_SEEN) === '1';
    var conn = navigator.connection || {};
    var calm = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || conn.saveData === true;
    var pv = null;
    var isOpen = false;
    var lastFocus = null;
    var lastSave = 0;

    if (seen) root.classList.add('is-mini');

    function track(name) {
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('sxtv_' + name, { video: vid });
        }
      } catch (e) {}
      try { if (window.dataLayer) window.dataLayer.push({ event: 'sxtv_' + name }); } catch (e) {}
    }

    /* Den lille preview uden lyd */
    function canPlayPreview() {
      return pv && !isOpen && !document.hidden && !root.classList.contains('is-yield');
    }
    function syncPreview() {
      if (!pv) return;
      if (canPlayPreview()) play(pv);
      else pv.pause();
    }
    function startPreview() {
      if (seen || calm || pv || root.classList.contains('is-yield')) return;
      pv = document.createElement('video');
      pv.className = 'sxtv__pv';
      pv.muted = true;
      pv.defaultMuted = true;
      pv.playsInline = true;
      pv.setAttribute('muted', '');
      pv.setAttribute('playsinline', '');
      pv.setAttribute('webkit-playsinline', '');
      pv.setAttribute('aria-hidden', 'true');
      pv.setAttribute('tabindex', '-1');
      pv.preload = 'auto';
      pv.addEventListener('timeupdate', function () {
        if (pv && pv.currentTime >= teaser) pv.currentTime = 0;
      });
      pv.addEventListener('ended', function () {
        if (!pv) return;
        pv.currentTime = 0;
        syncPreview();
      });
      pv.addEventListener('playing', function () { root.classList.add('is-live'); });
      pv.src = preview;
      bubble.insertBefore(pv, bubble.querySelector('.sxtv__label'));
      syncPreview();
    }
    function stopPreview() {
      if (!pv) return;
      pv.pause();
      pv.removeAttribute('src');
      pv.load();
      if (pv.parentNode) pv.parentNode.removeChild(pv);
      pv = null;
      root.classList.remove('is-live');
    }

    /* Vig for cookie-banneret og løft over produktsidens købsbar */
    var cookie = document.getElementById('m-cookie-banner');
    function checkCookie() {
      if (!cookie) return;
      var on = getComputedStyle(cookie).display !== 'none';
      root.classList.toggle('is-yield', on);
      if (on) syncPreview();
      else if (root.classList.contains('is-on')) { startPreview(); syncPreview(); }
    }
    var bar = document.querySelector('.sx__bar');
    function checkBar() {
      if (!bar) return;
      var on = bar.classList.contains('is-on') && getComputedStyle(bar).display !== 'none';
      root.style.setProperty('--sxtv-lift', on ? bar.offsetHeight + 'px' : '0px');
    }
    function observe(el, fn) {
      if (!el || !window.MutationObserver) return;
      new MutationObserver(fn).observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    observe(cookie, checkCookie);
    observe(bar, checkBar);

    // Ligger boblen oven på en knap eller et link? Roden er usynlig og uden pointer-events her,
    // så elementFromPoint rammer det der ligger under den
    function blocked() {
      var r = bubble.getBoundingClientRect();
      if (!r.width) return false;
      var xs = [0.15, 0.5, 0.85];
      var ys = [0.1, 0.5, 0.9];
      for (var i = 0; i < 3; i++) {
        for (var j = 0; j < 3; j++) {
          var el = document.elementFromPoint(r.left + r.width * xs[i], r.top + r.height * ys[j]);
          if (el && !root.contains(el) && el.closest &&
              el.closest('a[href], button, input, select, textarea, [role="button"]')) return true;
        }
      }
      return false;
    }
    function reveal() {
      root.classList.add('is-on');
      startPreview();
    }
    function show() {
      checkCookie();
      checkBar();
      root.hidden = false;
      frame(function () {
        if (design || !blocked()) { reveal(); return; }
        // Dækker den en knap ved første visning, venter den til der er scrollet lidt
        var from = window.scrollY;
        var busy = false;
        function onScroll() {
          if (busy) return;
          busy = true;
          requestAnimationFrame(function () {
            busy = false;
            if (Math.abs(window.scrollY - from) < 160 || blocked()) return;
            window.removeEventListener('scroll', onScroll);
            reveal();
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
      });
    }
    var booted = false;
    function boot() {
      if (booted) return;
      booted = true;
      setTimeout(show, seen ? 800 : 1200);
    }
    if (document.readyState === 'complete') boot();
    else {
      window.addEventListener('load', boot);
      setTimeout(boot, 4000);
    }

    /* Afspilleren med lyd */
    function syncMute() {
      card.classList.toggle('is-muted', big.muted);
      muteBtn.setAttribute('aria-label', big.muted ? 'Slå lyden til' : 'Slå lyden fra');
    }
    function savePos() {
      var d = big.duration || 0;
      if (!seen && d && big.currentTime > 0 && big.currentTime < d - 2.5) {
        put(LS, K_POS, String(Math.floor(big.currentTime)));
      }
    }
    function markSeen() {
      if (seen) return;
      seen = true;
      if (!design) put(LS, K_SEEN, '1');
      drop(LS, K_POS);
      track('complete');
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      syncPreview();
      if (!big.getAttribute('src')) big.src = full;
      endEl.hidden = true;
      card.classList.remove('is-ended');
      panel.hidden = false;
      document.documentElement.classList.add('sxtv-lock');
      frame(function () { panel.classList.add('is-open'); });

      var pos = parseFloat(get(LS, K_POS)) || 0;
      function seek() {
        var d = big.duration || 0;
        if (pos > 4 && d && pos < d - 4) big.currentTime = pos;
        else if (d && big.currentTime >= d - 0.5) big.currentTime = 0;
      }
      if (big.readyState >= 1) seek();
      else big.addEventListener('loadedmetadata', seek, { once: true });

      big.muted = false;
      var p = big.play();
      if (p && p.catch) p.catch(function () { big.muted = true; syncMute(); play(big); });
      syncMute();
      focus(closeBtn);
      track('open');
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      big.pause();
      savePos();
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('sxtv-lock');
      setTimeout(function () { if (!isOpen) panel.hidden = true; }, 260);
      if (seen && !root.classList.contains('is-mini')) {
        root.classList.add('is-mini');
        stopPreview();
      }
      syncPreview();
      focus(lastFocus && document.contains(lastFocus) ? lastFocus : bubble);
    }

    big.addEventListener('timeupdate', function () {
      var d = big.duration || 0;
      if (!d) return;
      prog.style.transform = 'scaleX(' + Math.min(1, big.currentTime / d) + ')';
      if (big.currentTime >= d - 2.5) markSeen();
      var now = Date.now();
      if (now - lastSave > 3000) { lastSave = now; savePos(); }
    });
    big.addEventListener('ended', function () {
      markSeen();
      card.classList.add('is-ended');
      endEl.hidden = false;
    });
    big.addEventListener('play', function () {
      card.classList.remove('is-paused');
      card.classList.remove('is-ended');
      endEl.hidden = true;
    });
    big.addEventListener('pause', function () { if (!big.ended) card.classList.add('is-paused'); });
    big.addEventListener('click', function () { if (big.paused) play(big); else big.pause(); });

    bubble.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    panel.addEventListener('click', function (e) { if (e.target === panel) close(); });
    muteBtn.addEventListener('click', function () {
      big.muted = !big.muted;
      syncMute();
      if (big.paused && !big.ended) play(big);
    });
    replayBtn.addEventListener('click', function () {
      endEl.hidden = true;
      card.classList.remove('is-ended');
      big.currentTime = 0;
      play(big);
      focus(closeBtn);
    });
    askLink.addEventListener('click', function (e) {
      track('ask');
      var cw = window.$chatway;
      if (cw && typeof cw.openChatwayWidget === 'function' && document.querySelector('.chatway--container')) {
        e.preventDefault();
        close();
        try { cw.openChatwayWidget(); } catch (err) { location.href = askLink.href; }
      }
    });
    xBtn.addEventListener('click', function () {
      put(SS, K_HIDE, '1');
      root.classList.remove('is-on');
      stopPreview();
      setTimeout(function () { root.hidden = true; }, 450);
      track('dismiss');
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(card.querySelectorAll('button, a[href]'), function (el) {
        return el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (!card.contains(document.activeElement)) { e.preventDefault(); focus(first); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); focus(last); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); focus(first); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && isOpen) big.pause();
      syncPreview();
    });
    window.addEventListener('pagehide', savePos);
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || design) return;
      if (!seen && get(LS, K_SEEN) === '1') {
        seen = true;
        root.classList.add('is-mini');
        stopPreview();
      }
      if (get(SS, K_HIDE) === '1') root.hidden = true;
      syncPreview();
    });
  }

  init();

  // Temaeditoren genindlæser sektionen ved hver ændring
  document.addEventListener('shopify:section:load', function (e) {
    var fresh = e.target && e.target.querySelector && e.target.querySelector('#sxtv-wrap');
    if (!fresh) return;
    Array.prototype.forEach.call(document.querySelectorAll('#sxtv-wrap'), function (n) {
      if (n !== fresh && n.parentNode) n.parentNode.removeChild(n);
    });
    init();
  });
})();
